import { initContract } from '@ts-rest/core';
const c = initContract();
export const pusherContract = c.router(
  {
    // pusherUserAuth: {
    //   method: 'POST',
    //   path: '/user-auth',
    //   responses: {
    //     200: c.type<{
    //       auth: string;
    //       user_data: string;
    //     }>(),
    //   },
    //   body: c.type<{ socket_id: string }>(),
    //   summary: 'Authenticate users pusher connection so they dont get kicked',
    // },
    channelAuth: {
      method: 'POST',
      path: '/channel-auth',
      responses: {
        200: c.type<{
          auth: string;
          channel_data?: string;
          shared_secret?: string;
        }>(),
      },
      body: c.type<{ socketId: string; channelName: string }>(),
      summary: 'Authenticate connection for private channel',
    },
  },
  {
    strictStatusCodes: true,
    pathPrefix: '/pusher',
  },
);
